<template>
        <div class="d-flex flex-wrap align-center">
            <a class="mt-1" :href="dashboardUrl"><v-icon>dashboard</v-icon>Dashboard</a>
            <a class="mt-1" :href="dailyPlannerUrl"><v-icon>edit_calendar</v-icon>Daily Planner</a>
            <a class="mt-1" :href="batchLoaderUrl"><v-icon>upload_file</v-icon>Batch Loader</a>
            <a class="mt-1" :href="specialOffersUrl"><v-icon>star</v-icon>Special Offers</a>
            <a class="mt-1" :href="changeLogUrl"><v-icon>history</v-icon>Change Log</a>
        </div>
</template>

<script>
    /**
     * Display buttons linking through to a hotels' pages
     */
    export default {
        props:['pageid'],

        data: function() {
            return {
                dashboardUrl: '',
                dailyPlannerUrl: '',
                batchLoaderUrl: '',
                specialOffersUrl: '',
                changeLogUrl: '',
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){
            this.dashboardUrl = '/hotels/' + this.pageid + '/dashboard';
            this.dailyPlannerUrl = "/hotels/" + this.pageid + '/daily-planner';
            this.batchLoaderUrl = '/hotels/' + this.pageid + '/batch-loader';
            this.specialOffersUrl = '';
            this.changeLogUrl = '';
        },

        methods: {},

        computed: {}
    }
</script>
<style>
    .major-icon {
        font-size: 5rem;
    }
</style>

